import React from 'react'
import { SalesAgenciesViewer } from "../../components/SalesAgenciesViewer/SalesAgenciesViewer";
import cn from './SalesAgencies.module.scss';

export class SalesAgenciesPage extends React.PureComponent {
  render() {
    return (
      <div className={cn.page}>
        <SalesAgenciesViewer/>
      </div>
    )
  }
}
